import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useLanguage } from '../hooks/useLanguage';

const LanguageRedirectHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentLanguage, supportedLanguages } = useLanguage();
  const lastProcessedPath = useRef('');
  
  useEffect(() => {
    if (lastProcessedPath.current === location.pathname) {
      return;
    }
    
    const pathParts = location.pathname.split('/').filter(Boolean);

    if (pathParts.length === 0) {
      lastProcessedPath.current = `/${currentLanguage}`;
      navigate(`/${currentLanguage}`, { replace: true });
      return;
    }
    
    const firstSegment = pathParts[0];
    
    if (supportedLanguages.includes(firstSegment)) {
      lastProcessedPath.current = location.pathname;
      return;
    }
    
    const knownRoutes = ['blog', 'about', 'contact', 'work', 'careers'];
    if (knownRoutes.includes(firstSegment)) {
      const newPath = `/${currentLanguage}${location.pathname}`;
      lastProcessedPath.current = newPath;
      navigate(newPath, { replace: true });
    }
    
  }, [location.pathname, currentLanguage, navigate, supportedLanguages]);
  
  return children;
};

export default LanguageRedirectHandler;